<template>
    <a :href="`/#/${props.type}/${item.id}`" class="m-article u-br u-shadow u-bgWhite u-p10 u-mb10">
        <div class="m-article__inner">
            <div v-if="item.image" class="m-article__imgHolder u-posRelative u-overflowHidden">
                <img :src="item.image" class="m-article__img u-br u-cover">
            </div>
            <div class="m-article__content">
                <h3 class="m-article__title u-fs16">{{ decodeHtml(item.title) }}</h3>
                <div class="m-article__bottom">
                    <ul v-if="item.categories && item.categories.length" class="m-article__tags m-tagList u-listUnstyled">
                        <li v-for="category in item.categories" :key="category.id">
                            <div class="a-tag">{{ category }}</div>
                        </li>
                    </ul>
                    <div v-if="item.date" class="m-article__date u-fs12 u-fw500 u-colorSecondary">
                        {{ item.date }}
                    </div>
                </div>
            </div>
        </div>
    </a>
</template>

<script setup>
const props = defineProps({
    item: {
        type: Object,
    },
    type: {
        type: String,
        default: 'knowledgebase'
    }
});

function decodeHtml(html) {
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
}
</script>